import { isFirefox, isSafari } from 'react-device-detect';
import MD5 from 'js-md5';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var asyncToGenerator = createCommonjsModule(function (module) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _asyncToGenerator = /*@__PURE__*/getDefaultExportFromCjs(asyncToGenerator);

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var regenerator = runtime_1;

var isSupportSharedArrayBuffer = typeof SharedArrayBuffer === 'function';
var piLib = null;
var session = null;
var promise = null;
var sessionPromise = null;
var input$1 = null;
var presentation = null;
var presenter = null;
var IE_RESOURCES_PATH = '';

try {
  IE_RESOURCES_PATH = 'https://dev-effres.picsart.com';
} catch (error) {
  IE_RESOURCES_PATH = 'https://dev-effres.picsart.com';
}

function createPiPromise() {
  var path = '/worker' + (isSupportSharedArrayBuffer && !isFirefox && !isSafari ? "/pi".concat('2022.6.8', ".js") : "/pi_no_threads".concat('2022.6.8', ".js"));
  var loadLib = import(
  /* webpackIgnore: true */
  path);

  if (!promise) {
    promise = new Promise(function (resolve, reject) {
      loadLib.then(function (_ref) {
        var createPIModule = _ref["default"];
        createPIModule({
          locateFile: function locateFile(path, scriptDirectory) {
            if ([".wasm", ".worker.js"].some(function (fragment) {
              return path.includes(fragment);
            })) {
              return '/worker' + '/' + path;
            }

            return scriptDirectory + path;
          },
          mainScriptUrlOrBlob: '/worker' + "/pi".concat('2022.6.8', ".js")
        }).then(function (wasm) {
          resolve(wasm);
        })["catch"](function (error) {
          reject(error);
        });
      })["catch"](function (error) {
        reject(error);
      });
    });
  }

  return promise;
}

function getPI() {
  return _getPI.apply(this, arguments);
}

function _getPI() {
  _getPI = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2() {
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!piLib) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", piLib);

          case 2:
            _context2.next = 4;
            return createPiPromise();

          case 4:
            piLib = _context2.sent;
            return _context2.abrupt("return", piLib);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getPI.apply(this, arguments);
}

function getSession() {
  if (session) return session;
  if (sessionPromise) return sessionPromise;
  return sessionPromise = new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(resolve, reject) {
      var pi;
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return getPI();

            case 3:
              pi = _context.sent;
              pi.canvas = pi.canvas || document.createElement('canvas');
              pi.canvas.width = 0;
              pi.canvas.height = 0; // GPU session use WebGL2 specific functions but GL session support WebGL

              if (typeof WebGL2RenderingContext !== 'undefined') {
                session = new pi.GPUSession(500);
              } else {
                session = new pi.GLSession(500);
              }

              resolve(session);
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              reject(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
}
function getInput() {
  return _getInput.apply(this, arguments);
}

function _getInput() {
  _getInput = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3() {
    var pi, session;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!input$1) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", input$1);

          case 2:
            _context3.next = 4;
            return getPI();

          case 4:
            pi = _context3.sent;

            if (!input$1) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", input$1);

          case 7:
            _context3.next = 9;
            return getSession();

          case 9:
            session = _context3.sent;

            if (!input$1) {
              _context3.next = 12;
              break;
            }

            return _context3.abrupt("return", input$1);

          case 12:
            session.accessGraph(function () {
              input$1 = pi.graph.value.Image_ARGB_8888();
            });
            return _context3.abrupt("return", input$1);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getInput.apply(this, arguments);
}

function getPresentation() {
  return _getPresentation.apply(this, arguments);
}

function _getPresentation() {
  _getPresentation = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4() {
    var pi, session;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!presentation) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", presentation);

          case 2:
            _context4.next = 4;
            return getPI();

          case 4:
            pi = _context4.sent;

            if (!presentation) {
              _context4.next = 7;
              break;
            }

            return _context4.abrupt("return", presentation);

          case 7:
            _context4.next = 9;
            return getSession();

          case 9:
            session = _context4.sent;

            if (!presentation) {
              _context4.next = 12;
              break;
            }

            return _context4.abrupt("return", presentation);

          case 12:
            // under condition depends on getSession(create Session is dynamic depends on browser) 
            if (typeof WebGL2RenderingContext === 'undefined') {
              // GPU session have not RXImageView presentation
              session.accessGraph(function () {
                presentation = pi.graph.undocumented.RXImageView({
                  value: pi.graph.value.Image_ARGB_8888(),
                  background: pi.graph.value.Image_ARGB_8888(),
                  size: pi.graph.value.Point2i(),
                  name: 'ImageView'
                });
              });
            } else {
              // GL session have not CheckerboardAndTransform presentation
              session.accessGraph(function () {
                presentation = pi.graph.undocumented.CheckerboardAndTransform({
                  image: pi.graph.value.Image_ARGB_8888(),
                  checkerboardRepeatCount: pi.graph.value.Int(1),
                  backgroundColor: pi.graph.value.ARGB_8888([0, 0, 0, 0]),
                  contentMode: pi.graph.value.Int(0),
                  outputSize: pi.graph.value.Point2i(),
                  name: 'ImageView'
                });
              });
            }

            return _context4.abrupt("return", presentation);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getPresentation.apply(this, arguments);
}

function getPresenter() {
  return _getPresenter.apply(this, arguments);
}

function _getPresenter() {
  _getPresenter = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5() {
    var presentation, session;
    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!presenter) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return", presenter);

          case 2:
            _context5.next = 4;
            return getPresentation();

          case 4:
            presentation = _context5.sent;

            if (!presenter) {
              _context5.next = 7;
              break;
            }

            return _context5.abrupt("return", presenter);

          case 7:
            _context5.next = 9;
            return getSession();

          case 9:
            session = _context5.sent;

            if (!presenter) {
              _context5.next = 12;
              break;
            }

            return _context5.abrupt("return", presenter);

          case 12:
            if (!(typeof WebGL2RenderingContext === 'undefined')) {
              _context5.next = 14;
              break;
            }

            return _context5.abrupt("return", presentation.output);

          case 14:
            session.accessGraph(function () {
              presenter = session.createPresenter(presentation);
            });
            return _context5.abrupt("return", presenter);

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getPresenter.apply(this, arguments);
}

var cache = {
  status: 'not-init',
  promise: null,
  module: null
};
function useWasm() {
  if (cache.status === 'reject') {
    return cache.module;
  }

  if (cache.status === 'resolve') {
    return cache.module;
  }

  if (cache.status === 'pending') {
    throw cache.promise;
  }

  if (cache.status === 'not-init') {
    cache.status = 'pending';
    cache.promise = getPI();
    cache.promise.then(function (wasm) {
      cache.module = wasm;
      cache.status = 'resolve';
    })["catch"](function (error) {
      console.error(error);
      cache.status = 'reject';
    });
    throw cache.promise;
  }
}

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _slicedToArray = /*@__PURE__*/getDefaultExportFromCjs(slicedToArray);

var extensionRegexp = /(?:\.([^.]+))?$/;
/**
 * createHashUrl generate md5 of string
 * @param {string} fileName 
 * @returns md5 of fileName + extension
 */

var createHashUrl = function createHashUrl(fileName) {
  var extension = extensionRegexp.exec(fileName)[0];
  var baseName = fileName.replace(extension, '');
  var nameHash = MD5(baseName);
  return "".concat(nameHash).concat(extension || '');
};

var resources = {};
var registeredEffectsBuilderCache = {};
var downloadedEffectJsonCache = {};
function downloadIEJson(_x) {
  return _downloadIEJson.apply(this, arguments);
}

function _downloadIEJson() {
  _downloadIEJson = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(name) {
    var subFolder,
        downloadedEffect,
        url,
        downloadedJsonString,
        _args2 = arguments;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            subFolder = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'effects';
            downloadedEffect = downloadedEffectJsonCache[name];

            if (!downloadedEffect) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", downloadedEffect);

          case 4:
            url = "".concat(IE_RESOURCES_PATH, "/").concat(subFolder, "/effects/").concat(createHashUrl(name));
            _context2.next = 7;
            return fetch(url, {
              importance: 'low'
            });

          case 7:
            _context2.next = 9;
            return _context2.sent.text();

          case 9:
            downloadedJsonString = _context2.sent;
            return _context2.abrupt("return", downloadedEffectJsonCache[name] = downloadedJsonString);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _downloadIEJson.apply(this, arguments);
}
function registerAndGetEffectsBuilder(_x2, _x3) {
  return _registerAndGetEffectsBuilder.apply(this, arguments);
}

function _registerAndGetEffectsBuilder() {
  _registerAndGetEffectsBuilder = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(name, downloadedJsonString) {
    var pi, builderFactory, _JSON$parse, nameFromDownloadedJson, currentBuilder;

    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!registeredEffectsBuilderCache[name]) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", registeredEffectsBuilderCache[name]);

          case 2:
            _context3.next = 4;
            return getPI();

          case 4:
            pi = _context3.sent;

            if (!registeredEffectsBuilderCache[name]) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", registeredEffectsBuilderCache[name]);

          case 7:
            builderFactory = pi.fx.core.BuilderFactory.factory();
            builderFactory.registerEffectFromData(downloadedJsonString, '', ''); //TODO need remove this line after json will be encoded 

            _JSON$parse = JSON.parse(downloadedJsonString), nameFromDownloadedJson = _JSON$parse.name;
            currentBuilder = builderFactory.createBuilder(nameFromDownloadedJson);
            return _context3.abrupt("return", registeredEffectsBuilderCache[name] = {
              builder: currentBuilder,
              cleanUp: function cleanUp() {
                builderFactory.remove(nameFromDownloadedJson);
                currentBuilder["delete"]();
                registeredEffectsBuilderCache[name] = null;
              }
            });

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _registerAndGetEffectsBuilder.apply(this, arguments);
}

var getEffectResource = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(effectName, requiredResourcesVector) {
    var subFolder,
        pi,
        res,
        resource,
        readyAllResourcePromise,
        _args = arguments;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            subFolder = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'effects';

            if (!resources[effectName]) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {
              resource: resources[effectName],
              effectName: effectName
            });

          case 3:
            _context.next = 5;
            return getPI();

          case 5:
            pi = _context.sent;

            if (!resources[effectName]) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              resource: resources[effectName],
              effectName: effectName
            });

          case 8:
            res = requiredResourcesVector;
            resource = new pi.fx.resources.VectorResource();

            if (!(res.size() === 0)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", {
              resource: resource,
              effectName: effectName
            });

          case 12:
            readyAllResourcePromise = new Promise(function (resolve, reject) {
              var resourcePromises = [];

              var _loop = function _loop(i) {
                var descriptor = res.get(i);
                var url = "".concat(IE_RESOURCES_PATH, "/").concat(subFolder, "/res/").concat(createHashUrl(descriptor.fileName));
                var piResources = pi.fx.resources;
                var encrypted = descriptor.isEncrypted;

                switch (descriptor.type) {
                  case pi.fx.resources.ResourceType.File:
                    {
                      resourcePromises.push(fetch(url, {
                        importance: 'low'
                      }).then(function (response) {
                        return response.text();
                      }).then(function (fileString) {
                        return new piResources.FileContentResource(fileString, descriptor);
                      }));
                      break;
                    }

                  case pi.fx.resources.ResourceType.Image:
                    {
                      switch (descriptor.exactType) {
                        case pi.ResourceExactType.ARGB:
                        case pi.ResourceExactType.LUT_ARGB:
                          {
                            resourcePromises.push(fetch(url, {
                              importance: 'low'
                            }).then(function (response) {
                              return response.arrayBuffer();
                            }).then(function (buffer) {
                              return pi.createImageARGB(buffer, encrypted);
                            }).then(function (image) {
                              var resourceImage = new piResources.ImageBufferARGB8Resource(image, descriptor);
                              image["delete"]();
                              return resourceImage;
                            }));
                            break;
                          }

                        case pi.ResourceExactType.Alpha:
                          {
                            resourcePromises.push(fetch(url, {
                              importance: 'low'
                            }).then(function (response) {
                              return response.arrayBuffer();
                            }).then(function (buffer) {
                              return pi.createImage8(buffer, encrypted);
                            }).then(function (image) {
                              var resourceImage = new piResources.ImageBuffer8Resource(image, descriptor);
                              image["delete"]();
                              return resourceImage;
                            }));
                            break;
                          }

                        default:
                          reject(new Error('Unsupported image resource type.'));
                      }

                      break;
                    }

                  default:
                    reject(new Error('Unsupported resource type.'));
                }
              };

              for (var i = 0; i < res.size(); ++i) {
                _loop(i);
              }

              res["delete"]();
              Promise.all(resourcePromises).then(function (result) {
                result.forEach(function (item) {
                  return resource.push_back(item);
                });
                resources[effectName] = resource;
                resolve({
                  resource: resource,
                  effectName: effectName
                });
              });
            });
            _context.next = 15;
            return readyAllResourcePromise;

          case 15:
            return _context.abrupt("return", _context.sent);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getEffectResource(_x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

var DEFAULT_WIDTH = 150;
var DEFAULT_HEIGHT = 150;

function paramToJsObject(param, pi) {
  var type = param.type;
  var object = {};
  object.defaultValue = param.defaultValue;
  object.name = param.name;
  object.value = param.value;
  object.localizedNameKey = param.localizedNameKey;

  switch (type) {
    case pi.fx.parameters.ParameterType.Bool:
      object.type = 'BOOLEAN';
      break;

    case pi.fx.parameters.ParameterType.Enum:
      {
        object.values = [];

        for (var i = 0; i < param.stringValues.size(); ++i) {
          object.values.push(param.stringValues.get(i));
        }

        object.type = 'ENUM';
        break;
      }

    case pi.fx.parameters.ParameterType.Int:
    case pi.fx.parameters.ParameterType.Float:
      object.type = 'NUMERIC';
      object.min = param.minValue;
      object.max = param.maxValue;
      break;

    case pi.fx.parameters.ParameterType.Point:
      object.type = 'POINT';
      object.min = {};
      object.max = {};
      object.min.x = param.minValue.x;
      object.min.y = param.minValue.y;
      object.max.x = param.maxValue.x;
      object.max.y = param.maxValue.y;
      object.value = {
        x: param.value.x,
        y: param.value.y
      };
      object.defaultValue = {
        x: param.defaultValue.x,
        y: param.defaultValue.y
      };
      break;

    case pi.fx.parameters.ParameterType.Color:
      object.type = 'COLOR';
      object.value = {
        a: param.value.a,
        r: param.value.r,
        g: param.value.g,
        b: param.value.b
      };
      object.defaultValue = {
        a: param.defaultValue.a,
        r: param.defaultValue.r,
        g: param.defaultValue.g,
        b: param.defaultValue.b
      };
      break;
  }

  return object;
}

function getParamsFromEffectsBuilder(IeEffectBuilder, pi) {
  var vector = IeEffectBuilder.parameters();
  var params = [];

  for (var i = 0; i < vector.size(); ++i) {
    var param = vector.get(i);
    params.push(paramToJsObject(param, pi));
  }

  return params;
}
function loadImage(_x2) {
  return _loadImage.apply(this, arguments);
}

function _loadImage() {
  _loadImage = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(url) {
    var image;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            image = new Image();
            return _context2.abrupt("return", new Promise(function (resolve) {
              image.onload = function () {
                resolve(image);
              };

              image.src = url;
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadImage.apply(this, arguments);
}

var getUrlExtension = function getUrlExtension(url) {
  try {
    var _url$split$pop, _url$split$pop$match;

    return (_url$split$pop = url.split('/').pop()) === null || _url$split$pop === void 0 ? void 0 : (_url$split$pop$match = _url$split$pop.match(/^[\w\s-,.]+\.([a-zA-Z0-9]{3,4})/)) === null || _url$split$pop$match === void 0 ? void 0 : _url$split$pop$match[1];
  } catch (ignored) {
    return false;
  }
};
var resizeObjects = function resizeObjects(originalWidth, originalHeight) {
  var resizeWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_WIDTH;
  var resizeHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_HEIGHT;
  var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'min';
  var method = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'floor';
  var ratio = Math[type](resizeWidth / originalWidth, resizeHeight / originalHeight);
  return {
    ratio: ratio,
    width: Math[method](ratio * originalWidth),
    height: Math[method](ratio * originalHeight)
  };
};
function getArrayBufferOrImageData(_x3) {
  return _getArrayBufferOrImageData.apply(this, arguments);
}

function _getArrayBufferOrImageData() {
  _getArrayBufferOrImageData = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(urlOrImageData) {
    var extension, response;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(urlOrImageData instanceof ImageData)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", urlOrImageData);

          case 2:
            extension = getUrlExtension(urlOrImageData);

            if (!(extension === 'gif')) {
              _context3.next = 7;
              break;
            }

            _context3.next = 6;
            return getFirstFrameFromGif(urlOrImageData);

          case 6:
            return _context3.abrupt("return", _context3.sent);

          case 7:
            _context3.next = 9;
            return fetch(urlOrImageData);

          case 9:
            response = _context3.sent;
            _context3.next = 12;
            return response.arrayBuffer();

          case 12:
            return _context3.abrupt("return", _context3.sent);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getArrayBufferOrImageData.apply(this, arguments);
}

function getFirstFrameFromGif(_x4) {
  return _getFirstFrameFromGif.apply(this, arguments);
}

function _getFirstFrameFromGif() {
  _getFirstFrameFromGif = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(url) {
    var canvas, ctx, image, imageData;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            canvas = document.createElement('canvas');
            ctx = canvas.getContext('2d');
            _context4.next = 4;
            return loadImage(url);

          case 4:
            image = _context4.sent;
            canvas.width = image.width;
            canvas.height = image.height;
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, 0, 0, image.width, image.height);
            imageData = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
            canvas.remove();
            return _context4.abrupt("return", imageData);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getFirstFrameFromGif.apply(this, arguments);
}

var effects = {};
/**
 * will return effect object of PiLib for name 
 * @param {string} graphName name of graph
 * @returns 
 */

function getGraph(_x, _x2) {
  return _getGraph.apply(this, arguments);
}

function _getGraph() {
  _getGraph = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(graphName, subFolder) {
    var pi, session, AIJson, _yield$registerAndGet, currentBuilder, builderCleanUp, resource, input, paramsMap, createdEffect, saveDelete;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getPI();

          case 2:
            pi = _context.sent;
            _context.next = 5;
            return getSession();

          case 5:
            session = _context.sent;
            _context.next = 8;
            return downloadIEJson(graphName, subFolder);

          case 8:
            AIJson = _context.sent;
            _context.next = 11;
            return registerAndGetEffectsBuilder(graphName, AIJson);

          case 11:
            _yield$registerAndGet = _context.sent;
            currentBuilder = _yield$registerAndGet.builder;
            builderCleanUp = _yield$registerAndGet.cleanUp;
            _context.next = 16;
            return getEffectResource(graphName, currentBuilder.requiredResources(), subFolder);

          case 16:
            resource = _context.sent;
            _context.next = 19;
            return getInput();

          case 19:
            input = _context.sent;
            paramsMap = new pi.fx.parameters.OverrideParameterMap();
            createdEffect = currentBuilder.buildEffectWithImage(session, input, resource.resource, paramsMap);
            saveDelete = createdEffect["delete"];

            createdEffect["delete"] = function () {
              builderCleanUp(); // effects[graphName] = null;

              saveDelete.call(createdEffect);
              paramsMap["delete"]();
            };

            return _context.abrupt("return", createdEffect);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getGraph.apply(this, arguments);
}

function getGraphByRawString$1(_x3, _x4) {
  return _getGraphByRawString.apply(this, arguments);
}
/**
 * preload all resources for graph work its not mandatory for work
 * @param {[{ graphName: string, subFolder?: string }]} effectsNames graph names 
 * @param {(name: string, params) => {}} callback callback will be called on etch graph params is ready
 */

function _getGraphByRawString() {
  _getGraphByRawString = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(name, rawString) {
    var effect, pi, session, AIJson, _yield$registerAndGet2, currentBuilder, builderCleanUp, resource, input, paramsMap, createdEffect, saveDelete;

    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            effect = effects[name];

            if (!effect) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", effect);

          case 3:
            _context2.next = 5;
            return getPI();

          case 5:
            pi = _context2.sent;

            if (!effects[name]) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", effects[name]);

          case 8:
            _context2.next = 10;
            return getSession();

          case 10:
            session = _context2.sent;

            if (!effects[name]) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", effects[name]);

          case 13:
            AIJson = rawString;
            _context2.next = 16;
            return registerAndGetEffectsBuilder(name, AIJson);

          case 16:
            _yield$registerAndGet2 = _context2.sent;
            currentBuilder = _yield$registerAndGet2.builder;
            builderCleanUp = _yield$registerAndGet2.cleanUp;

            if (!effects[name]) {
              _context2.next = 21;
              break;
            }

            return _context2.abrupt("return", effects[name]);

          case 21:
            _context2.next = 23;
            return getEffectResource(name, currentBuilder);

          case 23:
            resource = _context2.sent;

            if (!effects[name]) {
              _context2.next = 26;
              break;
            }

            return _context2.abrupt("return", effects[name]);

          case 26:
            _context2.next = 28;
            return getInput();

          case 28:
            input = _context2.sent;

            if (!effects[name]) {
              _context2.next = 31;
              break;
            }

            return _context2.abrupt("return", effects[name]);

          case 31:
            paramsMap = new pi.fx.parameters.OverrideParameterMap();
            createdEffect = currentBuilder.buildEffectWithImage(session, input, resource.resource, paramsMap);
            saveDelete = createdEffect["delete"];

            createdEffect["delete"] = function () {
              builderCleanUp();
              effects[graphName] = null;
              saveDelete.call(createdEffect);
              paramsMap["delete"]();
            };

            return _context2.abrupt("return", effects[name] = createdEffect);

          case 36:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getGraphByRawString.apply(this, arguments);
}

function preloadEffectsJson() {
  var effectsNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  if (!window || !window.requestIdleCallback) return;
  new Promise(function (resolve) {
    window.requestIdleCallback(function () {
      getPI().then(function (pi) {
        resolve(pi);
      });
    });
  }).then(function (pi) {
    effectsNames.forEach(function (_ref) {
      var graphName = _ref.graphName,
          subFolder = _ref.subFolder;
      window.requestIdleCallback(function () {
        getGraph(graphName, subFolder).then(function (effect) {
          callback === null || callback === void 0 ? void 0 : callback(graphName, getParamsFromEffectsBuilder(effect, pi));
        });
      });
    });
  });
}

var classCallCheck = createCommonjsModule(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _classCallCheck = /*@__PURE__*/getDefaultExportFromCjs(classCallCheck);

var createClass = createCommonjsModule(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _createClass = /*@__PURE__*/getDefaultExportFromCjs(createClass);

var WEBGL_RESIZE_ICON_SIZE = 350;
var InputImage = /*#__PURE__*/function () {
  /**
   * 
   * @param {*} pi 
   * @param {ArrayBuffer|ImageData} image imageData or decoded Arraybuffer <=> file
   */
  function InputImage(pi, image) {
    _classCallCheck(this, InputImage);

    this.pi = pi;

    if (image instanceof ImageData) {
      this._constructWithImageData(image);
    } else {
      this._constructWithArrayBuffer(image);
    }
  }

  _createClass(InputImage, [{
    key: "change",
    value: function change(image) {
      if (image instanceof ImageData) {
        this._constructWithImageData(image);
      } else {
        this._constructWithArrayBuffer(image);
      }
    }
  }, {
    key: "_constructWithArrayBuffer",
    value: function _constructWithArrayBuffer(buffer) {
      this.image = this.pi.createImageARGB(buffer);
      this.width = this.image.width;
      this.height = this.image.height;
      return this.image;
    }
  }, {
    key: "_constructWithImageData",
    value: function _constructWithImageData(imageData) {
      var tempImage = this.pi.core.ImageRGBA8.createFromDecodedBuffer(imageData.data, imageData.width, imageData.height);
      this.image = tempImage.convertARGB();
      this.width = this.image.width;
      this.height = this.image.height;
      tempImage["delete"]();
    }
  }, {
    key: "resizeImage",
    value: function resizeImage() {
      var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : WEBGL_RESIZE_ICON_SIZE;
      var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WEBGL_RESIZE_ICON_SIZE;
      var resizedSize = resizeObjects(this.image.width, this.image.height, width, height);
      return {
        pi: this.pi,
        image: this.pi.resizeImageARGB(this.image, resizedSize.width, resizedSize.height, 0, this.pi.InterpolationType.Linear)
      };
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _this$image;

      (_this$image = this.image) === null || _this$image === void 0 ? void 0 : _this$image["delete"]();
      this.width = 0;
      this.height = 0;
    }
  }]);

  return InputImage;
}();

var ReturnType = {
  BMP: 'BMP',
  PNG: 'PNG',
  CANVAS: 'CANVAS',
  IMAGE_DATA: 'IMAGE_DATA'
};
/**
 * 
 * @param {string} name name of graph
 * @param {string | ImageData} imageDataOrUrl image url or ImageData
 */

function setUpImage(_x) {
  return _setUpImage.apply(this, arguments);
}
/**
 * 
 * @param {string} name name of graph
 * @param {string} subFolder subFolder
 */

function _setUpImage() {
  _setUpImage = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(imageDataOrUrl) {
    var _yield$Promise$all, _yield$Promise$all2, pi, session, dataImage, notVirtualImage, virtualImage;

    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([getPI(), getSession(), getArrayBufferOrImageData(imageDataOrUrl)]);

          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            pi = _yield$Promise$all2[0];
            session = _yield$Promise$all2[1];
            dataImage = _yield$Promise$all2[2];
            notVirtualImage = new InputImage(pi, dataImage);
            virtualImage = null;
            session.accessGraph(function () {
              virtualImage = pi.graph.value.Image_ARGB_8888(notVirtualImage.image);
            });
            return _context.abrupt("return", {
              virtualImage: virtualImage,
              image: notVirtualImage,
              width: notVirtualImage.width,
              height: notVirtualImage.height,
              cleanup: function cleanup() {
                this.image["delete"]();
              },
              resize: function resize(width, height) {
                var notVirtualImage = this.image.resizeImage(width, height);
                var virtualImage = null;
                session.accessGraph(function () {
                  virtualImage = pi.graph.value.Image_ARGB_8888(notVirtualImage.image);
                });
                return {
                  virtualImage: virtualImage,
                  image: notVirtualImage,
                  width: notVirtualImage.width,
                  height: notVirtualImage.height,
                  cleanup: this.cleanup,
                  change: this.change
                };
              },
              change: function change(newImageDataOrUrl) {
                this.cleanup();
                this.image.change(newImageDataOrUrl);
              }
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _setUpImage.apply(this, arguments);
}

function setUpEffect(_x2) {
  return _setUpEffect.apply(this, arguments);
}

function _setUpEffect() {
  _setUpEffect = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee2(name) {
    var subFolder,
        _yield$Promise$all3,
        _yield$Promise$all4,
        pi,
        session,
        presentation,
        presenter,
        effect,
        input,
        _args2 = arguments;

    return regenerator.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            subFolder = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'effects';
            _context2.next = 3;
            return Promise.all([getPI(), getSession(), getPresentation(), getPresenter(), getGraph(name, subFolder), getInput()]);

          case 3:
            _yield$Promise$all3 = _context2.sent;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 6);
            pi = _yield$Promise$all4[0];
            session = _yield$Promise$all4[1];
            presentation = _yield$Promise$all4[2];
            presenter = _yield$Promise$all4[3];
            effect = _yield$Promise$all4[4];
            input = _yield$Promise$all4[5];
            return _context2.abrupt("return", {
              name: name,
              pi: pi,
              input: input,
              session: session,
              effect: effect,
              presentation: presentation,
              presenter: presenter,
              pending: false,
              getParams: function getParams() {
                return getParamsFromEffectsBuilder(effect, pi);
              },
              cleanup: function cleanup() {
                return effect["delete"]();
              },
              change: function change(name, callback) {
                var _this = this;

                this.pending = true;
                this.cleanup();
                getGraph(name).then(function (effect) {
                  _this.effect = effect;
                  _this.pending = false;
                  callback(_this);
                });
              }
            });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setUpEffect.apply(this, arguments);
}

function setUpEffectByRawString(_x3, _x4) {
  return _setUpEffectByRawString.apply(this, arguments);
}

function _setUpEffectByRawString() {
  _setUpEffectByRawString = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee4(name, rawString) {
    var _yield$Promise$all5, _yield$Promise$all6, pi, session, presentation, presenter, effect;

    return regenerator.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Promise.all([getPI(), getSession(), getPresentation(), getPresenter(), getGraphByRawString(name, rawString)]);

          case 2:
            _yield$Promise$all5 = _context4.sent;
            _yield$Promise$all6 = _slicedToArray(_yield$Promise$all5, 5);
            pi = _yield$Promise$all6[0];
            session = _yield$Promise$all6[1];
            presentation = _yield$Promise$all6[2];
            presenter = _yield$Promise$all6[3];
            effect = _yield$Promise$all6[4];
            return _context4.abrupt("return", {
              name: name,
              pi: pi,
              session: session,
              input: input,
              effect: effect,
              presentation: presentation,
              presenter: presenter,
              pending: false,
              getParams: function getParams() {
                return getParamsFromEffectsBuilder(effect, pi);
              },
              cleanup: function cleanup() {
                effect["delete"]();
              },
              change: function () {
                var _change = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee3(_ref, callback) {
                  var name, rawString;
                  return regenerator.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          name = _ref.name, rawString = _ref.rawString;
                          this.pending = true;
                          this.cleanup();
                          _context3.next = 5;
                          return getGraphByRawString(name, rawString);

                        case 5:
                          this.effect = _context3.sent;
                          this.pending = false;
                          callback(this);

                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, this);
                }));

                function change(_x6, _x7) {
                  return _change.apply(this, arguments);
                }

                return change;
              }()
            });

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _setUpEffectByRawString.apply(this, arguments);
}

function runSession(input, effect, params) {
  var imageReturnType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ReturnType.IMAGE_DATA;
  var pi = effect.pi,
      session = effect.session,
      runnableEffect = effect.effect,
      presentation = effect.presentation,
      presenter = effect.presenter,
      pending = effect.pending,
      getParams = effect.getParams;
      effect.input;
  if (pending === true) throw new Error('effect in pending mode');
  var virtualImage = input.virtualImage,
      width = input.width,
      height = input.height;
      input.image;
  var outputImage = null;
  var returnValue = null;
  session.accessGraph(function () {
    var _outputImage2;

    runnableEffect.changeInputValue('input_image', virtualImage);
    getParams().map(function (item) {
      return item.name;
    }).forEach(function (name) {
      if (params[name] === undefined) return;
      var currentParam = runnableEffect.parameter(name, true);
      currentParam.value = params[name];
    });
    outputImage = runnableEffect.outputImage();

    switch (imageReturnType) {
      case ReturnType.CANVAS:
        {
          pi.canvas.width = width;
          pi.canvas.height = height; // under condition depends on getSession(create Session is dynamic depends on browser) 

          if (typeof WebGL2RenderingContext === 'undefined') {
            presenter.node().setInput('value', outputImage);
            presenter.node().setInput('size', pi.graph.basic_operations.ShapeOf(outputImage).size);
          } else {
            presentation.node().setInput('image', outputImage);
            presentation.node().setInput('outputSize', pi.graph.basic_operations.ShapeOf(outputImage).size);
          }

          var result = session.runValue(presenter);
          returnValue = {
            result: pi.canvas,
            cleanup: function cleanup() {
              return result["delete"]();
            }
          };
          break;
        }

      case ReturnType.IMAGE_DATA:
        {
          var _result = session.runValue(outputImage);

          var tempResult = _result.getValue();

          var resultValue = tempResult.convertRGBA();
          tempResult["delete"]();
          var imageData = pi.core.ImageARGB8.getRawBuffer(resultValue);
          resultValue["delete"]();
          returnValue = {
            result: imageData,
            cleanup: function cleanup() {
              return _result["delete"]();
            }
          };
          break;
        }

      case ReturnType.BMP:
        {
          var _result2 = session.runValue(outputImage);

          var _resultValue = _result2.getValue();

          var buffer = pi.core.ImageARGB8.encodeToBMP(_resultValue);
          var blob = new Blob([buffer], {
            type: 'image/bmp'
          });

          _resultValue["delete"]();

          returnValue = {
            result: blob,
            cleanup: function cleanup() {
              return _result2["delete"]();
            }
          };
          break;
        }

      case ReturnType.PNG:
        {
          var _result3 = session.runValue(outputImage);

          var _resultValue2 = _result3.getValue();

          var _buffer = pi.core.ImageARGB8.encodeToPNG(_resultValue2);

          var _blob = new Blob([_buffer], {
            type: 'image/png'
          });

          _resultValue2["delete"]();

          returnValue = {
            result: _blob,
            cleanup: function cleanup() {
              return _result3["delete"]();
            }
          };
          break;
        }

      default:
        {
          var _outputImage;

          (_outputImage = outputImage) === null || _outputImage === void 0 ? void 0 : _outputImage["delete"]();
          throw new Error('unsupported return type');
        }
    }

    (_outputImage2 = outputImage) === null || _outputImage2 === void 0 ? void 0 : _outputImage2["delete"]();
  });
  return returnValue;
}
function drawImageOnCanvas(_x5) {
  return _drawImageOnCanvas.apply(this, arguments);
}

function _drawImageOnCanvas() {
  _drawImageOnCanvas = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee5(input) {
    var _yield$Promise$all7, _yield$Promise$all8, pi, session, presentation, presenter, virtualImage, width, height;

    return regenerator.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return Promise.all([getPI(), getSession(), getPresentation(), getPresenter()]);

          case 2:
            _yield$Promise$all7 = _context5.sent;
            _yield$Promise$all8 = _slicedToArray(_yield$Promise$all7, 4);
            pi = _yield$Promise$all8[0];
            session = _yield$Promise$all8[1];
            presentation = _yield$Promise$all8[2];
            presenter = _yield$Promise$all8[3];
            virtualImage = input.virtualImage, width = input.width, height = input.height;
            session.accessGraph(function () {
              pi.canvas.width = width;
              pi.canvas.height = height;
              presentation.node().setInput('image', virtualImage);
              presentation.node().setInput('outputSize', pi.graph.basic_operations.ShapeOf(virtualImage).size);
              var result = session.runValue(presenter);
              result["delete"]();
            });

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _drawImageOnCanvas.apply(this, arguments);
}

export { IE_RESOURCES_PATH, ReturnType, drawImageOnCanvas, getGraph, getGraphByRawString$1 as getGraphByRawString, getInput, getPI, getPresentation, getPresenter, getSession, preloadEffectsJson, runSession, setUpEffect, setUpEffectByRawString, setUpImage, useWasm };
